import React, { useEffect, useState } from 'react';
import { Table } from 'react-bootstrap';
import { Link, useLoaderData } from 'react-router-dom';
import AxiosInstance from 'src/components/Axios';
import dayjs from 'dayjs';
import { CButton, CFormInput } from '@coreui/react';
import SpecialMachinInformationModal from './SpecialMacinInformationModal';
import { currencyPairs } from '@mui/x-data-grid-generator';
import { confirmAlert } from 'react-confirm-alert';

import utc from 'dayjs/plugin/utc';

import RejectInformationForSendingModal from './RejectInformationForSendingModal';
import RejectInformationModal from './RejectInformationModal';
dayjs.extend(utc);

const urlApi_1 = '/special_machineries';
const urlApi_2 = '/special_machineries_types';
const urlApi_3 = '/special_machineries_docs';

const urlApi_4 = '/special_machineries_type_docs';
const urlApi_5 = '/media_objects'


// хто увійшов
const role = localStorage.getItem('user_role')
const user_data = JSON.parse(localStorage.getItem('user_data'))
const userName = user_data ? `${user_data?.first_name} ${user_data?.last_name} ` : ''
// console.log('role', role)
// console.log('user_data', user_data)
// console.log('userName', userName)




// const fakeDocs = [
//     {
//         // code: '',
//         // type: '',
//         fileName: 'Посвідчення водія',
//         // description: 'Документ водія',
//         ownerName: 'Петрів Петро Петрович',
//         dateEnd: "2025-04-25T08:32:34.981Z"

//     },
//     {
//         // code: '',
//         // type: '',
//         fileName: 'Техпаспорт',
//         // description: 'Документ водія',
//         ownerName: 'Павлів Павло Павлович',
//         dateEnd: "2025-04-25T08:32:34.981Z"

//     },
//     {
//         // code: '',
//         // type: '',
//         fileName: 'Страхівка',
//         // description: 'Документ водія',
//         ownerName: 'Мельник Микола Миколайович',
//         dateEnd: "2025-04-25T08:32:34.981Z"

//     },

// ]


export async function LoaderSpecialMachinInformation({ params }) {
    if (Object.keys(params).length != 0) {
        let res = await AxiosInstance.get(`${urlApi_1}/${params.pid}`, {
            params: {

            }
        }).then((response) => {
            // console.log("get /api/special_machineries/ response", response);
            return response;
        });
        return res;
    }
    return false;
}

// Інформація про спецтехніку (тільки для перегляду)
const SpecialMachinInformation = () => {

    const { data } = useLoaderData();
    useEffect(() => {
        // console.log('data', data);
        // console.log('type', type)
    }, [data]);

    const [name, setName] = useState(data?.name ?? '');
    const [number, setNumber] = useState(data?.number ?? '');
    const [code, setCode] = useState(data?.code ?? '');
    const [brand, setBrand] = useState(data?.brand ?? '');
    const [models, setModels] = useState(data?.models ?? '');
    const [description, setDescription] = useState(data?.description ?? '');
    const [atp, setAtp] = useState(data?.atp ?? '');
    const [type, setType] = useState(data?.type || "")
    const [driver, setDriver] = useState({})
    const [docs, setDocs] = useState(data.dosc || [])
    const [typeDocs, setTypeDocs] = useState([])
    const [jobs, setJobs] = useState()


    //  стани для модалки
    const [modalVisible, setModalVisible] = useState(false);
    const [currentTypeDoc, setCurrentTypeDoc] = useState(null);
    const [currentDoc, setCurrentDoc] = useState()
    const [formData, setFormData] = useState({
        name: '',
        // ownerName: '',
        // dateEnd: '',
        // dateModified: '',
        file: null
    });
    const [docDateEnd, setDocDateEnd] = useState('')

    //стан для роботи з модалкою для вводу коментаря
    const [rejectModalInformationForSendingVisible, setRejectModalInformationForSendingVisible] = useState(false);
    const [comment, setComment] = useState('');
    //збережений док для модалки написання коменту
    const [currentRejectDocId, setCurrentRejectDocId] = useState(null);

    // стан для роботи з модалкою для перегляду коментаря
    const [rejectModalInformationForReadingVisible, setRejectModalInformationForReadingVisible] = useState(false)
    //зберігаємо документ для модалки реджектед
    const [selectedDocForRejectInfo, setSelectedDocForRejectInfo] = useState(null);

    async function getJobs() {
        // return AxiosInstance.get(`${urlApi_3}/${data.id}`
        return AxiosInstance.get(`/jobs/${data.jobs[0].split('/')[3]}`
            , {
                params: {
                }
            }).then((response) => {
                // console.log("get /api/jobs/ response", response);
                setJobs(response.data)

                return response;
            }).catch(e => console.log(e))
    }

    async function getSpecialMachineriesDocs() {
        return AxiosInstance.get(`${urlApi_3}`
            , {
                params: {
                    "specialMachineries.id": data.id

                    // "specialMachineriesTypes.id": 1
                }
            }).then((response) => {
                console.log("get /api/special_machineries_docs/ response", response);
                setDocs(response.data['hydra:member'])

                return response;
            }).catch(e => console.log(e))
    }

    async function getSpecialMachineriesTypeDocs() {
        return AxiosInstance.get(`${urlApi_4}`
            , {
                params: {
                    // "specialMachineries.id": data.id
                    "specialMachineriesTypes.id": data.type.id
                }
            }).then((response) => {
                // console.log("get /api/special_machineries_type_docs/ response", response);
                if (response.data['hydra:member'].length > 0) {
                    setTypeDocs(response.data['hydra:member'])
                }
                return response;
            }).catch(e => console.log(e))
    }


    useEffect(() => {
        if (data?.type?.name) {
            getSpecialMachineriesTypeDocs()
        }
        if (data.jobs.length > 0) {
            getJobs()
        }
        // getSpecialMachineriesDocs()
    }, [])

    // console.log('typeDocs', typeDocs)
    // console.log('docs', docs)
    // console.log('jobs', jobs)
    // console.log('data', data)
    // console.log('docDateEnd', docDateEnd)

    const isFakeDate = (dateString) => dateString.startsWith("0100");

    function handleOpenModal(typedoc) {
        setCurrentTypeDoc(typedoc);
        setFormData({
            name: '',
            file: null
        });
        setModalVisible(true);
    }

    function handleOpenModalForUpdate(typedoc, doc) {
        console.log('doc', doc)
        setCurrentTypeDoc(typedoc);
        setCurrentDoc(doc)
        setFormData({
            name: '',
            file: null
        });
        setModalVisible(true);
    }





    async function createDocumentWithConfirm() {
        try {
            await confirmAlert({
                title: 'Увага',
                message: 'Ви впевнені що хочите підтвердити цей пункт ?',
                buttons: [
                    {
                        label: 'Так',
                        onClick: async () => createDocument()
                    },
                    {
                        label: 'Ні',
                        onClick: () => {
                            return
                        },
                    },
                ],
            })
        } catch (error) {
            console.error('Помилка видалення:', error)
        }
    }

    //   функція для створення документа
    function createDocument() {
        if (!docDateEnd) {
            console.error('Будь ласка, оберіть дату!');
            return;
        }

        const isoUtcDateEnd = new Date(`${docDateEnd}T00:00:00`).toISOString();
        // const isoUtcDateEnd = dayjs.utc(docDateEnd).startOf('day').toISOString();

        const data_for_sending = {
            ownerName: userName,
            specialMachineries: data['@id'],
            status: 'new',
            typeDocs: currentTypeDoc['@id'],
            dateEnd: isoUtcDateEnd,
            dateModified: dayjs().toISOString(),
            type: currentTypeDoc.type


        }


        const payload = new FormData();

        if (formData.file) {
            payload.append('file', formData.file);
            payload.append('name', formData.name)
        }

        AxiosInstance.post(
            `${urlApi_3}`,
            data_for_sending

        )
            .then((response) => {
                if (!formData.file) {
                    getSpecialMachineriesDocs();
                    return
                };


                console.log('Документ створено:', response.data);
                return AxiosInstance.post(`${urlApi_5}`, payload).then(res => {

                    return AxiosInstance.patch(`${urlApi_3}/${response.data.id}`, { media: `api/media_objects/${res.data.id}`, fileName: formData.name })


                })
                    .then(() => {
                        console.log('Документ і медіа успішно створені та пов’язані.');
                        getSpecialMachineriesDocs()
                        setDocDateEnd('')
                    })
                    .catch((err) => {
                        console.error('Помилка при створенні медіа або оновленні документа:', err);
                    });

            })
            .catch((error) => {
                console.error('Помилка при створенні документа:', error);
            });

    }



    async function updateDocumentWithConfirm() {
        try {
            await confirmAlert({
                title: 'Увага',
                message: 'Ви впевнені що хочите підтвердити цей пункт ?',
                buttons: [
                    {
                        label: 'Так',
                        onClick: async () => updateDocument()
                    },
                    {
                        label: 'Ні',
                        onClick: () => {
                            return
                        },
                    },
                ],
            })
        } catch (error) {
            console.error('Помилка видалення:', error)
        }
    }

    //   функція для редагування документа
    function updateDocument() {
        if (!docDateEnd) {
            console.error('Будь ласка, оберіть дату!');
            return;
        }

        // const isoUtcDateEnd = new Date(`${docDateEnd}T00:00:00`).toISOString();
        // const isoUtcDateEnd = dayjs.utc(docDateEnd).startOf('day').toISOString();
        let isoUtcDateEnd;

        try {
            if (docDateEnd.includes('T')) {
                isoUtcDateEnd = new Date(docDateEnd).toISOString();
            } else {
                isoUtcDateEnd = new Date(`${docDateEnd}T00:00:00`).toISOString();
            }
        } catch (error) {
            console.error('Невірна дата для перетворення:', docDateEnd, error);
            return;
        }


        const data_for_sending = {
            ownerName: userName,
            specialMachineries: data['@id'],
            status: currentDoc?.status || 'new',
            typeDocs: currentTypeDoc['@id'],
            dateEnd: isoUtcDateEnd,
            dateModified: dayjs().toISOString(),
            type: currentTypeDoc.type


        }


        const payload = new FormData();

        if (formData.file) {
            payload.append('file', formData.file);
            payload.append('name', formData.name)
        }

        AxiosInstance.put(
            `${urlApi_3}/${currentDoc.id}`,
            data_for_sending,
            {
                // headers: {
                //     'Content-Type': 'multipart/form-data',
                // },
            }
        )
            .then((response) => {
                if (!formData.file) {
                    getSpecialMachineriesDocs();
                    return
                };


                console.log('Документ оновлено:', response.data);
                return AxiosInstance.post(`${urlApi_5}`, payload).then(res => {

                    return AxiosInstance.patch(`${urlApi_3}/${response.data.id}`, { media: `api/media_objects/${res.data.id}`, fileName: formData.name })
                })
                    .then(() => {
                        console.log('Документ і медіа успішно оновлені та пов’язані.');
                        getSpecialMachineriesDocs()
                        setDocDateEnd('')
                    })
                    .catch((err) => {
                        console.error('Помилка при створенні медіа або оновленні документа:', err);
                    });

            })
            .catch((error) => {
                console.error('Помилка при створенні документа:', error);
            });

    }

    async function deleteDocumentWithConfirm(id) {
        try {
            await confirmAlert({
                title: 'Увага',
                message: 'Ви впевнені що хочите підтвердити цей пункт ?',
                buttons: [
                    {
                        label: 'Так',
                        onClick: async () => deleteDocument(id)
                    },
                    {
                        label: 'Ні',
                        onClick: () => {
                            return
                        },
                    },
                ],
            })
        } catch (error) {
            console.error('Помилка видалення:', error)
        }
    }



    // функція для видалення документа
    function deleteDocument(id) {

        AxiosInstance.delete(
            `${urlApi_3}/${id}`
        )
            .then((response) => {
                getSpecialMachineriesDocs()
            })
            .catch((error) => {
                console.error('Помилка при створенні документа:', error);
            });

    }

    // функціі для зміни статусів
    // зміна статуса на send_to_verify
    async function changeStatusForSendToVerifyWithAlert(id) {
        try {
            await confirmAlert({
                title: 'Увага',
                message: 'Ви впевнені що хочите підтвердити цей пункт ?',
                buttons: [
                    {
                        label: 'Так',
                        onClick: async () => changeStatusForSendToVerify(id)
                    },
                    {
                        label: 'Ні',
                        onClick: () => {
                            return
                        },
                    },
                ],
            })
        } catch (error) {
            console.error('Помилка видалення:', error)
        }

    }
    function changeStatusForSendToVerify(id) {
        const data_response = { status: 'send_to_verify', dateModified: dayjs().toISOString(), descripton: '' }
        AxiosInstance.patch(
            `${urlApi_3}/${id}`,
            data_response,
            // header,
        ).then(
            (response) => {
                console.log('Статус оновлено:', response.data);
                setDocs(
                    (prev) =>
                        prev.map((doc) =>
                            doc.id === id ? { ...doc, ...data_response } : doc
                        )
                )
            }
        ).catch((error) => {
            console.error('Помилка при оновленні статусу:', error);
        });
    }


    // зміна статуса на verified

    async function changeStatusToVerifiedWithConfirm(id) {
        try {
            await confirmAlert({
                title: 'Увага',
                message: 'Ви впевнені що хочите підтвердити цей пункт ?',
                buttons: [
                    {
                        label: 'Так',
                        onClick: async () => changeStatusToVerified(id)
                    },
                    {
                        label: 'Ні',
                        onClick: () => {
                            return
                        },
                    },
                ],
            })
        } catch (error) {
            console.error('Помилка видалення:', error)
        }
    }

    function changeStatusToVerified(id) {
        const data_response = { status: 'verified', dateModified: dayjs().toISOString(), descripton: '' }
        AxiosInstance.patch(
            `${urlApi_3}/${id}`,
            data_response,
            // header,
        ).then(
            (response) => {
                console.log('Статус оновлено:', response.data);
                setDocs(
                    (prev) =>
                        prev.map((doc) =>
                            doc.id === id ? { ...doc, ...data_response } : doc
                        )
                )

            }
        ).catch((error) => {
            console.error('Помилка при оновленні статусу:', error);
        });
    }

    //зміна статуса на rejected

    // async function changeStatusToRejectedWithConfirm(id) {
    //     try {
    //         await confirmAlert({
    //             title: 'Увага',
    //             message: 'Ви впевнені що хочите підтвердити цей пункт ?',
    //             buttons: [
    //                 {
    //                     label: 'Так',
    //                     onClick: async () => changeStatusToRejected(id)
    //                 },
    //                 {
    //                     label: 'Ні',
    //                     onClick: () => {
    //                         return
    //                     },
    //                 },
    //             ],
    //         })
    //     } catch (error) {
    //         console.error('Помилка видалення:', error)
    //     }
    // }

    // відправка модалки при відмові(rejected)
    const rejectedModalHandleSend = (id) => {
        console.log('Відправлено повідомлення:', comment);
        changeStatusToRejected(id)
        // setVisible(false);
        setRejectModalInformationForSendingVisible(false)
        setComment('');
        setCurrentRejectDocId(null)

    };

    function changeStatusToRejected(id) {
        const data_response = { status: 'rejected', dateModified: dayjs().toISOString(), descripton: comment }
        AxiosInstance.patch(
            `${urlApi_3}/${id}`,
            data_response,
            // header,
        ).then(
            (response) => {
                console.log('Статус оновлено:', response.data);
                setDocs(
                    (prev) =>
                        prev.map((doc) =>
                            doc.id === id ? { ...doc, ...data_response } : doc
                        )
                )

            }
        ).catch((error) => {
            console.error('Помилка при оновленні статусу:', error);
        });
    }

    function translateStatus(status) {
        let translatedStatus;
        if (status === 'new') {
            translatedStatus = 'новий'
        }
        else if (status === 'send_to_verify') {
            translatedStatus = "відправлено на перевірку"
        } else if (status === 'verified') {
            translatedStatus = 'перевірено'
        } else if (status === 'rejected') {
            translatedStatus = 'відмовлено'
        } else if (status === 'synced') {
            translatedStatus = 'синхронізовано з 1с'
        }
        return translatedStatus.toUpperCase() || ''
    }

    // console.log('formData', formData.dateEnd)
    // console.log('docs', docs)


    return (
        <div>
            {modalVisible && <SpecialMachinInformationModal
                updateDocumentWithConfirm={updateDocumentWithConfirm}
                createDocumentWithConfirm={createDocumentWithConfirm} data={data}
                docDateEnd={docDateEnd} setDocDateEnd={setDocDateEnd}
                createDocument={createDocument} updateDocument={updateDocument} userName={userName} formData={formData} setFormData={setFormData} currentTypeDoc={currentTypeDoc} currentDoc={currentDoc} setCurrentDoc={setCurrentDoc} setModalVisible={setModalVisible} modalVisible={modalVisible}
            />}
            {selectedDocForRejectInfo && (
                <RejectInformationModal
                    visible={rejectModalInformationForReadingVisible}
                    setVisible={setRejectModalInformationForReadingVisible}
                    reason={selectedDocForRejectInfo?.descripton}
                    setSelectedDocForRejectInfo={setSelectedDocForRejectInfo}
                />
            )}
            <RejectInformationForSendingModal
                visible={rejectModalInformationForSendingVisible}
                setVisible={setRejectModalInformationForSendingVisible}
                comment={comment}
                setComment={setComment}
                handleSend={rejectedModalHandleSend}
                setCurrentRejectDocId={setCurrentRejectDocId}
                docId={currentRejectDocId}
            />

            <h1 className="mb-3">{name}</h1>

            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th className='specialMachines-table__th1'>#</th>
                        <th className='specialMachines-table__th2'>Назва</th>
                        <th>Значення</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className='specialMachines-table__td1'>1</td>
                        <td>Назва</td>
                        <td>{name}</td>
                    </tr>
                    <tr>
                        <td className='specialMachines-table__td1'>2</td>
                        <td>Номер</td>
                        <td>{number}</td>
                    </tr>
                    <tr>
                        <td className='specialMachines-table__td1'>3</td>
                        <td>Код</td>
                        <td>{code}</td>
                    </tr>
                    <tr>
                        <td className='specialMachines-table__td1'>4</td>
                        <td>Бренд</td>
                        <td>{brand}</td>
                    </tr>
                    <tr>
                        <td className='specialMachines-table__td1'>5</td>
                        <td>Модель</td>
                        <td>{models}</td>
                    </tr>
                    <tr>
                        <td className='specialMachines-table__td1'>6</td>
                        <td>Опис</td>
                        {/* <td dangerouslySetInnerHTML={{ __html: description }}></td> */}
                        <td>{description}</td>
                    </tr>
                    <tr>
                        <td className='specialMachines-table__td1'>7</td>
                        <td>АТП</td>
                        <td>{atp?.name}</td>
                    </tr>
                    {/* Додавання типу */}
                    <tr>
                        <td className='specialMachines-table__td1'>8</td>
                        <td>Тип</td>
                        <td>
                            {/* {atp?.name} */}
                            {type?.name || <span style={{ color: 'red' }}>Додайте тип техніки</span>}
                        </td>
                    </tr>

                </tbody>
            </Table>
            {/* Таблиця для документів */}


            <Table striped bordered hover>


                <thead>
                </thead>
                <tbody>
                    {/* Варіант з одним документом кожного типу (закоментовано) */}
                    {/* <>

                        <div style={{
                            display: "flex",
                            justifyContent: 'space-between',
                            border: '1px solid #dee2e6',
                            gap: '10px',
                            fontWeight: 'bold',
                            textAlign: 'center'
                        }}>
                            <div style={{ width: '40px', textAlign: 'center' }}>#</div>
                            <div style={{ width: '200px' }}>Назва</div>
                            <div style={{ width: '200px' }}>Власник</div>
                            <div style={{ width: '100px' }}>Термін дії</div>
                            <div style={{ width: '100px' }}>Дата зміни</div>
                            <div style={{ width: '100px' }}>Додати документ</div>
                        </div>




                        {typeDocs.map((typeDoc, index) => {
                            const matchedDoc = docs.find(doc => doc.typeDocs === typeDoc['@id']);

                            return (
                                <div key={index}>
                                    <div
                                        // key={index}
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            gap: '10px',
                                            borderTop: '1px solid #dee2e6',
                                            borderLeft: '1px solid #dee2e6',
                                            borderRight: '1px solid #dee2e6',
                                            borderBottom: '1px dashed #dee2e6',
                                        }}>
                                        <div style={{ width: '40px' }} className='specialMachines-table__td1' >{index + 1}</div>
                                        <div style={{ width: '200px' }} className='specialMachines-table__td1'>{typeDoc.type}</div>
                                        <div style={{ width: '200px' }} className='specialMachines-table__td1'>
                                            {matchedDoc?.ownerName || <span style={{ color: 'red' }}>Відсутній</span>}
                                        </div>
                                        <div style={{ width: '100px' }} className='specialMachines-table__td1'>
                                            {matchedDoc?.dateEnd
                                                ? isFakeDate(matchedDoc.dateEnd)
                                                    ? <span style={{ color: 'red' }}>Терміну дії не вказано</span>
                                                    : (
                                                        <span style={{
                                                            color: dayjs(matchedDoc.dateEnd).isBefore(dayjs(jobs?.dateEnd)) ? 'red' : 'green'
                                                        }}>
                                                            {dayjs(matchedDoc.dateEnd).local().format('YYYY-MM-DD HH:mm:ss')}
                                                        </span>
                                                    )
                                                : <span style={{ color: 'gray' }}>—</span>
                                            }
                                        </div>
                                        <div style={{ width: '100px' }} className='specialMachines-table__td1'>
                                            {matchedDoc?.dateModified
                                                ? dayjs(matchedDoc.dateModified).local().format('YYYY-MM-DD HH:mm:ss')
                                                : <span style={{ color: 'gray' }}>—</span>
                                            }
                                        </div>
                                        <div style={{
                                            width: '100px', display: 'flex', flexDirection: 'column', gap: '5px',
                                            justifyContent: "center", alignItems: 'center'
                                        }}>
                                            <label htmlFor="customFileUpload" className="btn btn-primary">
                                                Вибрати
                                            </label>

                                            <CFormInput
                                                type="file"

                                                id="customFileUpload"
                                                style={{ display: 'none' }}


                                            />

                                            <CButton


                                                color="secondary"

                                            >
                                                +
                                            </CButton>
                                        </div>
                                    </div>



                                    {matchedDoc?.fileName && (
                                        <div
                                            style={{
                                                display: 'flex',

                                                justifyContent: 'space-between',
                                                gap: '10px',
                                                padding: '5px 40px 10px',
                                                borderLeft: '1px solid #dee2e6',
                                                borderRight: '1px solid #dee2e6',
                                                borderBottom: '1px dotted #dee2e6',
                                                fontSize: '14px',
                                                color: '#444',
                                            }}
                                        >
                                            <a
                                                href={matchedDoc.fileName}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{ textDecoration: 'underline' }}
                                            >
                                                📎 Переглянути файл
                                            </a>
                                            <CButton
                                                color="danger"
                                                size="sm"
                                                onClick={() => handleDeleteDoc(matchedDoc.id)}
                                            >
                                                🗑
                                            </CButton>
                                        </div>
                                    )}



                                    {matchedDoc?.fileName && <div style={{
                                        display: 'flex', justifyContent: 'space-between', borderLeft: '1px solid #dee2e6',
                                        borderRight: '1px solid #dee2e6',
                                    }}>

                                        {role === 'ROLE_PARTNER' &&

                                            <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end' }}>
                                                <CButton
                                                    color="success"

                                                >
                                                    Відправити на перевірку
                                                </CButton>
                                            </div>


                                        }
                                        {role === 'ROLE_ADMIN' &&

                                            <div style={{ marginTop: '20px', display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                                                <CButton
                                                    color="success"

                                                >
                                                    Підтвердити
                                                </CButton>

                                                <CButton
                                                    color="danger"
                                                    variant="outline"

                                                >
                                                    Повернути на доопрацювання
                                                </CButton>
                                            </div>
                                        }
                                    </div>}


                                </div>

                            );
                        })}

                    </> */}

                    {/* Варіант з можливістю декількох документів одного типу */}

                    {/* Заголовок */}
                    {data?.type && <div style={{
                        display: "flex",
                        justifyContent: 'space-between',
                        border: '1px solid #dee2e6',
                        gap: '10px',
                        fontWeight: 'bold',
                        textAlign: 'center'
                    }}>
                        <div style={{ width: '40px' }}>#</div>
                        <div style={{ width: '200px' }}>Назва</div>
                        <div style={{ width: '200px' }}>Власник</div>
                        <div style={{ width: '100px' }}>Термін дії</div>
                        <div style={{ width: '100px' }}>Дата зміни</div>
                        <div style={{ width: '100px' }}>Додати документ</div>
                    </div>}

                    {/* По кожному типу документа */}
                    {typeDocs.map((typeDoc, index) => {
                        // console.log('typeDoc', typeDoc)
                        const matchedDocs = docs.filter(doc => doc.typeDocs === typeDoc['@id']);

                        const sortedDocs = [...matchedDocs].sort((a, b) => new Date(a.dateEntered || 0) - new Date(b.dateEntered || 0));


                        return (
                            <div key={index} >
                                {sortedDocs.length > 0 ? sortedDocs.map((doc, i) => {
                                    {/* {matchedDocs.length > 0 ? matchedDocs.map((doc, i) => { */ }


                                    // const lastDoc = [...matchedDocs].sort((a, b) => new Date(b.dateEntered || 0) - new Date(a.dateEntered || 0))[0];

                                    // const lastDoc = sortedDocs[0];
                                    const lastDoc = sortedDocs[sortedDocs.length - 1];
                                    const isLastDoc = doc.id === lastDoc.id;


                                    return (


                                        <div key={doc.id}
                                            style={{ border: "1px solid #dee2e6" }}
                                        >
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                gap: '10px',
                                                // borderTop: i === 0 ? '1px solid #dee2e6' : 'none',
                                                // borderLeft: '1px solid #dee2e6',
                                                // borderRight: '1px solid #dee2e6',
                                                // borderBottom: '1px dashed #dee2e6',
                                            }}>
                                                <div style={{ width: '40px', marginLeft: '5px' }}>{index + 1}</div>
                                                <div style={{ width: '200px', textAlign: 'center' }}>{typeDoc.type}</div>
                                                <div style={{ width: '200px', textAlign: 'center' }}>{doc.ownerName || <span style={{ color: 'red' }}>Відсутній</span>}</div>
                                                <div style={{ width: '100px', textAlign: 'center' }}>
                                                    {doc.dateEnd
                                                        ? isFakeDate(doc.dateEnd)
                                                            ? <span style={{ color: 'red' }}>Терміну дії не вказано</span>
                                                            : (
                                                                <span style={{
                                                                    color: dayjs(doc.dateEnd).isBefore(dayjs(jobs?.dateEnd)) ? 'red' : 'green'
                                                                }}>
                                                                    {dayjs(doc.dateEnd).local().format('YYYY-MM-DD HH:mm:ss')}
                                                                </span>
                                                            )
                                                        : <span style={{ color: 'gray' }}>—</span>
                                                    }
                                                </div>
                                                <div style={{ width: '100px', textAlign: 'center' }}>
                                                    {doc.dateModified
                                                        ? dayjs(doc.dateModified).local().format('YYYY-MM-DD HH:mm:ss')
                                                        : <span style={{ color: 'gray' }}>—</span>
                                                    }
                                                </div>
                                                <div style={{
                                                    width: '100px',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    gap: '5px',
                                                    alignItems: 'center'
                                                }}>

                                                    {isLastDoc && <>
                                                        <label htmlFor={`fileUpload-${typeDoc.id}-${doc.id}`}
                                                            disabled={doc.status !== 'new' && doc.status !== 'rejected'}
                                                            onClick={() => {
                                                                if (doc.status === 'new' || doc.status === 'rejected') {
                                                                    handleOpenModalForUpdate(typeDoc, doc);
                                                                }
                                                            }}
                                                            // onClick={() => {
                                                            //     handleOpenModalForUpdate(typeDoc, doc)
                                                            // }}
                                                            className="btn btn-primary"
                                                            style={{
                                                                pointerEvents: doc.status !== 'new' && doc.status !== 'rejected' ? 'none' : 'auto',
                                                                opacity: doc.status !== 'new' && doc.status !== 'rejected' ? 0.6 : 1,
                                                                cursor: doc.status !== 'new' && doc.status !== 'rejected' ? 'not-allowed' : 'pointer',
                                                            }}


                                                        >Оновити</label>
                                                        <CFormInput

                                                            type="button"
                                                            id={`fileUpload-${typeDoc.id}-${doc.id}`}
                                                            style={{ display: 'none' }}
                                                        // onChange={}
                                                        />
                                                        {/* <CButton color="secondary">+</CButton> */}
                                                    </>}

                                                </div>
                                            </div>

                                            {/* Блок "Переглянути файл" */}
                                            {/* {doc.media &&  */}

                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                padding: '5px 30px 10px',
                                                gap: '10px',
                                                // borderLeft: '1px solid #dee2e6',
                                                // borderRight: '1px solid #dee2e6',
                                                // borderBottom: '1px dotted #dee2e6',
                                                fontSize: '14px',
                                                color: '#444'
                                            }}>
                                                {(doc?.media
                                                    // && isLastDoc
                                                ) && <a
                                                    // href={`${process.env.REACT_APP_SERVER_URL}${doc.media.contentUrl}`}
                                                    href={
                                                        doc?.media?.contentUrl
                                                            ? `${process.env.REACT_APP_SERVER_URL}${doc.media.contentUrl}`
                                                            : '#'
                                                    }
                                                    target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline', cursor: 'pointer' }}>
                                                        📎 {doc.media.contentUrl.match(/[^/]+_(.+)$/)?.[1] ?? 'Переглянути файл'}
                                                    </a>}
                                                <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                                                    {(doc.status === 'rejected' && role === 'ROLE_PARTNER' && doc?.descripton) &&
                                                        <>

                                                            <CButton size="sm" color="warning" onClick={() => {
                                                                setRejectModalInformationForReadingVisible(true)
                                                                setSelectedDocForRejectInfo(doc)
                                                            }
                                                            }>
                                                                Показати причину відмови
                                                            </CButton>
                                                            {/* <RejectInformationModal
                                                                visible={rejectModalInformationForReadingVisible}
                                                                setVisible={setRejectModalInformationForReadingVisible}
                                                                reason={doc?.descripton}
                                                            /> */}

                                                        </>
                                                    }
                                                    <div style={{
                                                        fontSize: '20px',
                                                        //  color: 'blue',
                                                        color:
                                                            doc?.status === 'rejected'
                                                                ? 'red'
                                                                : doc?.status === 'synced'
                                                                    ? 'orange'
                                                                    : 'blue',
                                                        fontWeight: '700'
                                                    }}>{doc?.status ? `статус : ${translateStatus(doc?.status)}` : ''}</div>
                                                    <CButton
                                                        disabled={doc.status !== 'new' && doc.status !== 'rejected'}
                                                        style={{
                                                            // marginLeft: 'auto',
                                                            width: 'auto'

                                                        }} size="sm" color="danger" onClick={() => deleteDocumentWithConfirm(doc.id)}>🗑</CButton>

                                                    {/* } */}
                                                </div>
                                            </div>

                                            {/* } */}



                                            {
                                                (doc.media && isLastDoc) && (
                                                    <div style={{
                                                        display: 'flex',
                                                        justifyContent: 'flex-end',
                                                        gap: '10px',
                                                        padding: '10px',
                                                        // borderLeft: '1px solid #dee2e6',
                                                        // borderRight: '1px solid #dee2e6'
                                                    }}>
                                                        {role === 'ROLE_PARTNER' && (doc.status === 'new' || doc.status === 'rejected') && (
                                                            <CButton
                                                                onClick={() => changeStatusForSendToVerifyWithAlert(doc.id)}
                                                                color="success">Відправити на перевірку</CButton>
                                                        )}
                                                        {role === 'ROLE_ADMIN' && (doc.status === 'send_to_verify') && (
                                                            <>
                                                                <CButton
                                                                    onClick={() => {
                                                                        changeStatusToVerifiedWithConfirm(doc.id)
                                                                    }
                                                                    }
                                                                    color="success"
                                                                >Підтвердити</CButton>
                                                                <CButton
                                                                    onClick={() => {
                                                                        setCurrentRejectDocId(doc.id)
                                                                        setRejectModalInformationForSendingVisible(true)
                                                                        // changeStatusToRejectedWithConfirm(doc.id)
                                                                    }
                                                                    }
                                                                    color="danger" variant="outline">Повернути на доопрацювання</CButton>

                                                                {/* <RejectInformationForSendingModal
                                                                    visible={rejectModalInformationForSendingVisible}
                                                                    setVisible={setRejectModalInformationForSendingVisible}
                                                                    comment={comment}
                                                                    setComment={setComment}
                                                                    handleSend={rejectedModalHandleSend}
                                                                    docId={doc.id}
                                                                /> */}
                                                            </>
                                                        )}

                                                        {
                                                            role === 'ROLE_ADMIN' && (doc?.status === "verified") &&
                                                            <>
                                                                <CButton
                                                                    className="ms-3"
                                                                    color="primary"
                                                                >
                                                                    Перевірено
                                                                </CButton>
                                                            </>
                                                        }

                                                        {
                                                            role === 'ROLE_ADMIN' && (doc?.status === "rejected") &&
                                                            <>
                                                                <CButton
                                                                    className="ms-3"
                                                                    color="danger"
                                                                >
                                                                    Повернуто на доопрацювання
                                                                </CButton>

                                                            </>
                                                        }
                                                        {
                                                            role === 'ROLE_ADMIN' && (doc?.status === "synced") &&
                                                            <>
                                                                <CButton
                                                                    // style={{ background: 'orange' }}
                                                                    className="ms-3"
                                                                    color="warning"
                                                                >
                                                                    Внесено в 1c
                                                                </CButton>
                                                            </>
                                                        }


                                                    </div>
                                                )
                                            }


                                        </div>
                                    )
                                }

                                ) : (

                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        gap: '10px',
                                        borderTop: '1px solid #dee2e6',
                                        borderLeft: '1px solid #dee2e6',
                                        borderRight: '1px solid #dee2e6',
                                        borderBottom: '1px dashed #dee2e6',
                                        padding: '10px'
                                    }}>
                                        <div style={{ width: '40px', marginLeft: '5px' }}>{index + 1}</div>
                                        <div style={{ width: '200px', textAlign: 'center' }}>{typeDoc.type}</div>
                                        <div style={{ width: '200px', color: 'red', textAlign: 'center' }}>Відсутній</div>
                                        <div style={{ width: '100px', textAlign: 'center' }}>—</div>
                                        <div style={{ width: '100px', textAlign: 'center' }}>—</div>
                                        <div style={{
                                            width: '100px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: '5px',
                                            alignItems: 'center'
                                        }}>
                                            <span>—</span>
                                            {/* <label htmlFor={`fileUpload-empty-${typeDoc.id}`} className="btn btn-primary">
                                                Вибрати
                                              
                                            </label> */}
                                            {/* <CFormInput
                                                type="file"
                                                id={`fileUpload-empty-${typeDoc.id}`}
                                                style={{ display: 'none' }}
                                                disabled

                                            />
                                            <CButton disabled color="secondary">+</CButton> */}
                                        </div>
                                    </div>
                                )}
                                {/* Тут має бути кнопка додати документ */}

                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    borderLeft: '1px solid #dee2e6',
                                    borderRight: '1px solid #dee2e6',
                                    borderBottom: '1px dashed #dee2e6',
                                    padding: '10px'
                                }}>
                                    <CButton
                                        color="primary"
                                        onClick={() => handleOpenModal(typeDoc)}
                                    >
                                        ➕ Додати документ
                                    </CButton>
                                </div>



                            </div>
                        );
                    })}




                </tbody>

            </Table>

        </div >
    );
};

export default SpecialMachinInformation;